<template>
  <v-card class="responsive-base-card-rm" outlined>
    <v-card-title class="justify-space-between">
      <span class="label-main-title">{{ $t('documentRequest.client.reqForMemberTitle') }}</span>
      <v-chip class="ma-2 d-label-required-bg" label text-color="white">
        {{ $t('common.labelRequired') }}
      </v-chip>
    </v-card-title>
    <v-card-subtitle>
      <span v-if="typeValid === 'REQ_CHECKBOX_RFM'" class="error--text">Required</span>
    </v-card-subtitle>
    <v-card-text>
      <v-row class="ml-2">
        <div>
          <v-radio-group class="flex-fill justify-space-between" row v-model="vModelCheckReqForMember">
            <v-col cols="12" sm="6" md="4" v-for="item in items" :key="item.value">
              <v-radio
                :label="item.text"
                :value="item.value"
                hide-details
                :rules="rules"
                @change="onClickChangeReqForMember"
              />
            </v-col>
          </v-radio-group>
          <div class="note" v-if="noticeForVsUrl">
            ※一部の東急バケーションズ施設は2026年11月30日をもって営業終了いたします。予めご了承ください。<br>
            &nbsp;<a :href="noticeForVsUrl" target="_blank">詳しくはこちら</a><br>
          </div>
          <div class="note">
            ※会員プラン・サービス内容の見直しを実施することに伴い、Vacation Mastersの販売を終了させていただくこととなりました。<br>
            &nbsp;東急バケーションズへ新たにご入会をお考えのお客様は、Vacation Styleをご検討ください。
          </div>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import C from '@/utils/constant'

export default {
  name: 'RequestForMember',
  data () {
    return {
      items: [],
      vModelCheckReqForMember: ''
    }
  },
  props: {
    typeValid: {
      type: String,
      required: false
    }
  },
  model: {
    event: 'eventChangeRequestForMember'
  },
  mounted () {
    this.items = this.initItems()
    this.$nextTick(() => {
      this.vModelCheckReqForMember = this.dataClientDocRequest.requestForMember?.value
      this.onClickChangeReqForMember()
    })
  },
  methods: {
    initItems () {
      return [{
      //   text: this.$t('documentRequest.client.reqForMemberData.primeMember'),
      //   value: this.constant.WEB_REQUEST_FOR_TYPE_MEMBER.primeMember
      // }, {
        // only VS is available now. see TO2020-1589
        text: this.$t('documentRequest.client.reqForMemberData.yes'),
        value: this.constant.WEB_REQUEST_FOR_TYPE_MEMBER.vacationsClubMember
      // }, {
      //   text: this.$t('documentRequest.client.reqForMemberData.bothHope'),
      //   value: this.constant.WEB_REQUEST_FOR_TYPE_MEMBER.bothHope
      }]
    },
    onClickChangeReqForMember () {
      this.$nextTick(() => {
        const find = this.items.find(ele => ele.value === this.vModelCheckReqForMember)
        this.$emit('eventChangeRequestForMember', (find || {}))
      })
    }
  },
  computed: {
    ...mapState({
      // Format [stageName] => state.[modulesName].[stageName],
      dataClientDocRequest: state => state.documentRequest.dataClientDocRequest
    }),
    constant () {
      return Object.assign({}, C)
    },
    rules () {
      return [
        (this.vModelCheckReqForMember && Object.keys(this.vModelCheckReqForMember).length > 0) || this.$t('rules.selected')
      ]
    },
    noticeForVsUrl () {
      return process.env.VUE_APP_NOTICE_FOR_VS_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.responsive-base-card-rm {
  border: 2px solid #C2AD37 !important;
  margin-bottom: 68px;
}
.note {
  text-indent: -1em;
  padding-left: 1em;
  font-size: 0.875rem;
}
</style>
